import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import arabic from "./arab.json";
import english from "./english.json";
import spanish from "./spanish.json";
import catalan from "./catalan.json";
import portuguese from "./portuguese.json";

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: { translation: english },
      ar: { translation: arabic },
      es: { translation: spanish },
      ca: { translation: catalan },
      pt: { translation: portuguese },
    },

    react: {
      useSuspense: false, 
    },
  });

export default i18n;